<template>
  <div id="nav">
    <a class="nav_logo" href="javascript:void(0)" @click="goHome()">
      <!-- <el-image class="nav_logo" :src="url" :fit="fit"></el-image> -->
      <img
        alt="投票、企业投票云服务、企业投票、网络投票、微信投票、会议投票"
        src="../assets/images/logo.png"
      />
    </a>
    <div class="menu_box hidden-sm-and-down menu_box_margin_left">
      <el-menu
        :default-active="topMenuActiveIndex"
        class="el-menu-demo hidden-xs-only"
        mode="horizontal"
        @select="topHandleSelect"
        background-color="#ffffff"
        text-color="#333"
        active-text-color="#ea6f5a"
      >
        <el-menu-item index="1" class="el-menu-item-height">首页</el-menu-item>
        <el-menu-item index="2" class="el-menu-item-height"
          >场景介绍</el-menu-item
        >
        <el-menu-item index="3" class="el-menu-item-height"
          >成功案例</el-menu-item
        >
        <el-menu-item index="4" class="el-menu-item-height"
          >教程讲解</el-menu-item
        >
        <el-menu-item index="5" class="el-menu-item-height"
          >资费介绍</el-menu-item
        >
        <el-menu-item index="6" class="el-menu-item-height"
          >关于我们</el-menu-item
        >
        <!-- <el-menu-item index="001" class="el-menu-item-height">
          <img
            alt="电力工程云服务平台"
            style="height: 24px"
            src="https://www.ceppea.com/resource/img/logo.png"
          />
        </el-menu-item> -->
      </el-menu>
    </div>
    <div class="nav_right">
      <!-- <a
        title="用户手册"
        href="#/manua"
        target="_blank"
        style="color: #409eff; margin-right: 20px"
      >
        <i
          class="iconfont icon-bangzhu"
          style="vertical-align: initial; margin-right: 0px"
        ></i>
        用户手册
      </a> -->
      <router-link
        class="nav_right_link hidden-sm-and-down"
        :to="{ name: 'style' }"
        v-if="false"
      >
        网站样式
      </router-link>
      <router-link
        class="nav_right_link"
        :to="{
          name: 'login',
          params: { loginType: 'signIn' },
          query: { redirect: this.$route.path }
        }"
        v-if="!this.$store.state.isLogin"
        >登录</router-link
      >
      <el-link
        class="nav_right_btn hidden-md-and-down"
        :underline="false"
        v-if="!this.$store.state.isLogin"
        @click="signup()"
      >
        用户注册
      </el-link>
      <el-link
        class="nav_right_btn"
        href="#/meetingList"
        :underline="false"
        v-if="this.$store.state.isLogin"
        >管理后台</el-link
      >
      <el-link
        class="nav_right_link hidden-sm-and-down"
        @click="userOut()"
        :underline="false"
        v-if="this.$store.state.isLogin"
        >退出</el-link
      >
      <a @click="drawerChange()" class="nav_right_menuIcon hidden-md-and-up">
        <i class="iconfont icon-menu-s" style="font-size: 24px"></i>
      </a>
    </div>
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      size="260px"
      class="nav_right_menu"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <ul>
        <li
          :class="{ nav_right_menu_item_active: rightMenuActiveIndex === 2 }"
          @click="rightMenuSelect(2)"
          v-if="!this.$store.state.isLogin"
        >
          注册
        </li>
        <el-divider></el-divider>
        <li
          :class="{ nav_right_menu_item_active: rightMenuActiveIndex === 3 }"
          @click="rightMenuSelect(3)"
        >
          首页
        </li>
        <li
          :class="{ nav_right_menu_item_active: rightMenuActiveIndex === 4 }"
          @click="rightMenuSelect(4)"
        >
          场景介绍
        </li>
        <li
          :class="{ nav_right_menu_item_active: rightMenuActiveIndex === 5 }"
          @click="rightMenuSelect(5)"
        >
          成功案例
        </li>
        <li
          :class="{ nav_right_menu_item_active: rightMenuActiveIndex === 6 }"
          @click="rightMenuSelect(6)"
        >
          教程讲解
        </li>
        <li
          :class="{ nav_right_menu_item_active: rightMenuActiveIndex === 7 }"
          @click="rightMenuSelect(7)"
        >
          资费介绍
        </li>
        <li
          :class="{ nav_right_menu_item_active: rightMenuActiveIndex === 8 }"
          @click="rightMenuSelect(8)"
        >
          关于我们
        </li>
        <!-- <li
          :class="{ nav_right_menu_item_active: rightMenuActiveIndex === 99 }"
          @click="rightMenuSelect(99)"
        >
          电力工程云服务平台
        </li> -->
        <el-divider v-if="this.$store.state.isLogin"></el-divider>
        <li
          :class="{ nav_right_menu_item_active: rightMenuActiveIndex === 9 }"
          @click="rightMenuSelect(9)"
          v-if="this.$store.state.isLogin"
        >
          <i class="el-icon-switch-button"></i>
          退出
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fit: 'contain',
      url: require('../assets/images/logo.png'),
      topMenuActiveIndex: '1',
      rightMenuActiveIndex: 0,
      drawer: false
    }
  },
  methods: {
    goHome: function () {
      window.location.href = '/index.html'
    },
    topHandleSelect (key, keyPath) {
      // const routerJump = this.$router.resolve({ name: 'manua' })
      switch (key) {
        case '1':
          // this.$router.push({ path: '/home' })
          window.location.href = '/index.html'
          break
        case '2':
          //   this.$router.push({ path: '/scene' })
          window.location.href = '/scene.html'
          break
        case '3':
          //   this.$router.push({ path: '/case' })
          window.location.href = '/case.html'
          break
        case '4':
          //   this.$router.push({ path: '/course' })
          window.location.href = '/course.html'
          break
        case '5':
          //   this.$router.push({ path: '/fee' })
          window.location.href = '/fee.html'
          break
        case '6':
          //   this.$router.push({ path: '/about' })
          window.location.href = '/about.html'
          break
        case '001':
          window.open('https://www.ceppea.com', '_blank')
          break
      }
    },
    // 退出登录
    userOut: function () {
      this.$confirm('确认退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        this.$store.commit('REMOVE_ACCOUNT')
        this.$router.go(0)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出登录',
          customClass: 'custom_message'
        })
      })
      // sessionStorage.removeItem("token", token);
    },
    routeChange (pathName) {
      switch (pathName) {
        case 'home':
          this.topMenuActiveIndex = '1'
          break
        case 'scene':
          this.topMenuActiveIndex = '2'
          break
        case 'case':
          this.topMenuActiveIndex = '3'
          break
        case 'course':
          this.topMenuActiveIndex = '4'
          break
        case 'fee':
          this.topMenuActiveIndex = '5'
          break
        case 'about':
          this.topMenuActiveIndex = '6'
          break
      }
    },
    signup: function () {
      this.$router.push({ name: 'login', params: { loginType: 'register' }, query: { redirect: this.$route.path } })
    },
    rightMenuSelect (key) {
      this.rightMenuActiveIndex = key
      this.drawer = false
      switch (key) {
        case 1:
          this.$router.push({ path: '#/meetingList' })
          break
        case 2:
          this.$router.push({ name: 'login', params: { loginType: 'register' }, query: { redirect: this.$route.path } })
          break
        case 3:
          //   this.$router.push({ path: '/home' })
          window.location.href = '/index.html'
          this.topMenuActiveIndex = '1'
          break
        case 4:
          //   this.$router.push({ path: '/scene' })
          window.location.href = '/scene.html'
          this.topMenuActiveIndex = '2'
          break
        case 5:
          // this.$router.push({ path: '/case' })
          window.location.href = '/case.html'
          this.topMenuActiveIndex = '3'
          break
        case 6:
          // this.$router.push({ path: '/course' })
          window.location.href = '/course.html'
          this.topMenuActiveIndex = '4'
          break
        case 7:
          // this.$router.push({ path: '/fee' })
          window.location.href = '/fee.html'
          this.topMenuActiveIndex = '5'
          break
        case 8:
          // this.$router.push({ path: '/about' })
          window.location.href = '/about.html'
          this.topMenuActiveIndex = '6'
          break
        case 9:
          this.userOut()
          this.topMenuActiveIndex = ''
          break
        case 99:
          window.open('https://www.ceppea.com', '_blank')
          this.topMenuActiveIndex = '001'
          break
      }
    },
    drawerChange: function () {
      this.drawer = !this.drawer
    }
  },
  created () {
    this.routeChange(this.$route.name)
    if (window.location.hostname === 'kaihui.suizhi.com') {
      var bp = document.createElement('script')
      var curProtocol = window.location.protocol.split(':')[0]
      if (curProtocol === 'https') {
        bp.src = 'https://zz.bdstatic.com/linksubmit/push.js'
      } else {
        bp.src = 'http://push.zhanzhang.baidu.com/push.js'
      }
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(bp, s)
    }
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route (to, from) {
      this.routeChange(to.pathName)
    }
  }
}
</script>
<style lang="less">
.el-divider--horizontal {
  margin: 3px 0px;
}
</style>
